@if (this.showHeader) {

<app-header [isAuthenticated]="isAuthenticated" [userName]="userName">
</app-header>

<app-menu [showHostedPortal]="showHostedPortal" [showMySoftProUsers]="showMySoftProUsers"
  [showOnlineBillPay]="showOnlineBillPay">
</app-menu>
}

<main>
  <router-outlet></router-outlet>
</main>

<app-footer [url]="url"></app-footer>